import { trackAmplitudeEvent } from '@/plugins/amplitude.js';

/**
 * Short class name of a bell row, e.g. `App\Models\CourseAnnouncement` -> `CourseAnnouncement`.
 *
 * @param {string|null|undefined} className
 * @returns {string|null}
 */
export function notificationTypeFromClass(className) {
    if (!className) return null;

    return String(className).split('\\').pop();
}

/**
 * @param {number} unreadCount
 */
export function trackNotificationBellOpened(unreadCount) {
    trackAmplitudeEvent('Notification Bell Opened', {
        unread_count: Number(unreadCount) || 0,
    });
}

/**
 * Sends only the row's class and read state; never titles, bodies or people.
 *
 * @param {{class?: string, read?: boolean}} notification
 */
export function trackNotificationBellItemOpened(notification) {
    trackAmplitudeEvent('Notification Bell Item Opened', {
        notification_type: notificationTypeFromClass(notification?.class),
        was_unread: !notification?.read,
    });
}
